export default {
    contentModule: {
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        width: '100%',
        position: 'relative',
        boxSizing: 'border-box',
    },
    contentModuleRow: {
        display: 'flex',
    },
    contentModuleCell: {
        font: "500 18px 'Roboto', sans-serif",
        display: 'table-cell',
        width: '50%',
        '&$short': {
            width: '35%'
        },
        '&$large': {
            width: '65%'
        },
    },
    contentModuleCellPrice: {
        font: "500 20px 'Roboto', sans-serif",
        display: 'block',
        textAlign: 'right',
    },
    equivalentBlock: {
        marginTop: '-15px',
        textAlign: 'right',
    }
}